export default function ReadMoreButton({ link }) {
    return (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--green"
        >
            Read More →
        </a>
    );
}
